export default {
  menuEstaExpandido: false,
};